import React, { createContext, useContext, useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { useSamplerCart } from '../../shopify/useSamplerCart';

const defaultCartState = {
  cartId: null,
  couponCode: null,
  isLoading: false,
  addPromo: offerCode => Promise.resolve(null),
};

export const SamplerCartContext = createContext(defaultCartState);

export const SamplerCartProvider = ({ children }) => {
  const router = useRouter();
  const [shouldCreateCart, setShouldCreateCart] = useState(false);
  const [hasCheckedPath, setHasCheckedPath] = useState(false);

  useEffect(() => {
    if (router.isReady) {
      setShouldCreateCart(router.pathname.includes('/sampler-box'));
      setHasCheckedPath(true);
    }
  }, [router.isReady, router.pathname]);

  const cartState = useSamplerCart({
    shouldCreateCart,
    hasCheckedPath,
  });

  return (
    <SamplerCartContext.Provider value={cartState}>
      {children}
    </SamplerCartContext.Provider>
  );
};
export const useSamplerCartContext = () => {
  const context = useContext(SamplerCartContext);
  if (!context) {
    // Shopify TODO: remove this once we have production validated
    // eslint-disable-next-line no-console
    console.warn(
      'useSamplerCartContext called outside of SamplerCartProvider, using fallback values',
    );
  }

  return context;
};
